import React from 'react';
import render from 'react-render-html';
import { VStack } from '~/native-ui/native-base';
import { List } from '~/native-ui/List';
import { Link } from '~/native-ui/Link';
import { Text, Small, Strong } from '~/native-ui/Typography';
import { Tooltip } from 'native-base';

const MemoizedSpan = React.memo(({ title, ...prop }) => {
    return title ? (
        <Tooltip label={title} hasArrow>
            <MemoizedText maxWidth="100%" width="max-content" {...prop} lineHeight="inherit" fontFamily="inherit" />
        </Tooltip>
    ) : (
        <MemoizedText {...prop} lineHeight="inherit" fontFamily="inherit" maxWidth="100%" />
    );
});

const MemoizedText = React.memo(
    React.forwardRef(({ value, ...props }, ref) => {
        return (
            <Text fontSize="inherit" lineHeight="inherit" fontWeight="inherit" {...props} ref={ref}>
                {value}
                {props.children}
            </Text>
        );
    })
);

const UnstyledList = React.memo((props) => {
    return (
        <List ul={false} ol={false} {...props}>
            {React.Children.map(props.children, (child, i) => (
                <React.Fragment key={i}>{React.cloneElement(child, { pl: '0', unstyled: true })}</React.Fragment>
            ))}
        </List>
    );
});

const customComponents = {
    Text: MemoizedText,
    a: Link,
    ul: UnstyledList,
    ol: List.Ordered,
    li: List.Item,
    span: MemoizedSpan,
    small: Small,
    strong: Strong,
    div: VStack,
    br: () => null,
};

export const renderHTML = (html, components = {}) => {
    return render(html, { ...customComponents, ...components });
};
